module.exports = __webpack_public_path__ + "static/media/language.109abfc3.svg";